export const shouldUsePaywallMode = (
  _recLeague: Models.RecLeague,
  _isEffectiveMember: boolean
) => {
  return false;
};
